import React, { useState } from "react";
import { FaUserMd, FaMinus, FaPlus, FaHeartbeat, FaNotesMedical, FaCapsules, FaMicroscope, FaDna, FaVials, FaChartLine, FaClipboardCheck } from "react-icons/fa";
import Medpalm from "../../../assests/HealthcarePLS/Clinic.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {

        title: "Drug Discovery & Research",
        description: "The initial phase of drug development where scientists identify potential drug candidates by studying disease mechanisms and biological targets. High-throughput screening, computational modeling, and AI-driven drug design are used to analyze thousands of compounds. Researchers optimize lead compounds to enhance their efficacy, reduce toxicity, and improve selectivity before proceeding to preclinical studies."
    },
    {

        title: "Preclinical Studies",
        description: "Before human trials, drug candidates undergo rigorous laboratory and animal testing to evaluate their safety, toxicity, and biological effects. These studies focus on pharmacokinetics (absorption, distribution, metabolism, and excretion) and pharmacodynamics (mechanism of action). Data from preclinical studies help determine appropriate dosage levels and potential side effects, ensuring the drug is safe for human testing."
    },
    {

        title: "Clinical Trial Management",
        description: "Clinical trials are conducted in multiple phases (I-IV) to test the safety, effectiveness, and long-term impact of a drug in humans. Phase I tests safety and dosage in a small group of healthy volunteers or patients. Phase II evaluates efficacy and side effects in a larger patient group. Phase III involves large-scale studies comparing the drug to standard treatments, leading to regulatory approval. Phase IV continues post-approval monitoring in real-world settings."
    },
    {

        title: "Regulatory Affairs & Compliance",
        description: "Ensuring compliance with global regulatory standards set by agencies like the FDA (U.S.), EMA (Europe), and WHO. This involves preparing and submitting clinical trial data, obtaining necessary approvals, and maintaining adherence to Good Manufacturing Practices (GMP). Regulatory teams also handle safety reporting, labeling requirements, and post-market compliance audits."
    },
    {

        title: "Biopharmaceutical Development",
        description: "The advancement of complex biological therapies, including monoclonal antibodies, gene therapy, mRNA vaccines, and cell-based treatments. This process involves optimizing production techniques, ensuring stability, and conducting specialized clinical trials to bring innovative biologic-based medicines to patients. Personalized medicine approaches are also explored to develop targeted therapies based on genetic profiles."
    },
    {

        title: "Pharmacovigilance & Safety Monitoring",
        description: "Post-market surveillance to continuously monitor the safety and effectiveness of approved drugs. This includes tracking adverse drug reactions, collecting real-world safety data, and updating risk assessments. Regulatory agencies may require label modifications, safety warnings, or even drug withdrawals if significant risks are identified over time."
    }
];
const features = [
    { icon: <FaMicroscope className="text-[#2a627a] text-lg" />, text: "Robust clinical trials ensuring drug safety and efficacy." },
    { icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />, text: "Randomized controlled trials for unbiased and accurate results." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Collaboration with regulatory authorities for compliance." },
    { icon: <FaVials className="text-[#2a627a] text-lg" />, text: "Innovative methodologies, including real-world evidence (RWE)." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Adaptive trial designs to improve efficiency and effectiveness." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Ethical patient recruitment with strict safety protocols." }
];

const benefits = [
    { icon: <FaHeartbeat className="text-[#2a627a] text-lg" />, text: "Faster access to cutting-edge medical treatments." },
    { icon: <FaCapsules className="text-[#2a627a] text-lg" />, text: "Ensures that drugs are both safe and effective before public use." },
    { icon: <FaChartLine className="text-[#2a627a] text-lg" />, text: "Accelerates the approval process for new life-saving drugs." },
    { icon: <FaVials className="text-[#2a627a] text-lg" />, text: "Provides valuable insights for drug improvements and advancements." },
    { icon: <FaUserMd className="text-[#2a627a] text-lg" />, text: "Enhances healthcare quality through continuous medical innovation." },
    { icon: <FaNotesMedical className="text-[#2a627a] text-lg" />, text: "Long-term safety monitoring ensuring public health security." }
];
const cmsFeatures = [
    {
        icon: <FaUserMd className="text-[#2a627a] text-lg" />,
        title: "Clinical Research Scientist",
        text: "Designs and oversees clinical studies to evaluate new drug candidates and treatments."
    },
    {
        icon: <FaMicroscope className="text-[#2a627a] text-lg" />,
        title: "Pharmacologist",
        text: "Analyzes the effects of drugs on biological systems to ensure safety and effectiveness."
    },
    {
        icon: <FaDna className="text-[#2a627a] text-lg" />,
        title: "Biotechnology Specialist",
        text: "Develops personalized medicine, biologics, and gene therapy for targeted treatments."
    },
    {
        icon: <FaClipboardCheck className="text-[#2a627a] text-lg" />,
        title: "Regulatory Affairs Specialist",
        text: "Manages compliance with FDA, EMA, and other regulatory agencies for trial approvals."
    }
];
const ClinicalTrials = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800  justify-center items-center flex">Clinical Trials - <span className="text-gray-800">HIKEHEALTH GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        " Ensuring the safety, efficacy, and reliability of new treatments through ethical, controlled, and scientifically rigorous testing on human participants."
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]"> What is Clinical Trials?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Clinical trials at HikeHealth GS are research studies conducted to evaluate new medical treatments, drugs, or therapies in human volunteers. These trials follow a structured process, including Phase I (safety testing), Phase II (efficacy evaluation), Phase III (large-scale testing), and Phase IV (post-market monitoring). Our goal is to ensure the safety and effectiveness of new treatments while adhering to strict regulatory guidelines. HikeHealth GS is committed to advancing healthcare through innovative and ethical clinical research.
                        </p>
                    </div>
                </section>

                {/* Role in AI&Machine */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in Clinical Trials
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default ClinicalTrials;
